import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxCaption4WarningCenter extends ITextBoxProps {}

export const TextBoxCaption4WarningCenter = ({
  title = '',
  color = Colors.ADDITIONAL_RED_2,
  font = TextBoxTypes.Caption4,
  alignment = TextAligning.Center,
  ...rest
}: ITextBoxCaption4WarningCenter): JSX.Element => (
  <TextBox
    title={title}
    color={color}
    font={font}
    alignment={alignment}
    {...rest}
  />
)
